export const dossierTypeDtoFields = [{
        name: "numCode",
        title: "Codice",
        render: (record) => record.dossierType.numCode
    }, {
        name: "dossierCategoryDescription",
        title: "Categoria",
        render: (record) => record.dossierCategoryDescription
    }, {
        name: "description",
        title: "Descrizione",
        render: (record) => record.dossierType.description
    }];
